// https://sendbird.com/docs/chat/uikit/v3/react/tutorial/apply-brand-color#2-how-to-customize-3-step-2-change-the-property
export const sendBirdColorSet = {
  // Keep UIKit's color-set API, but source the actual shades from the shell
  // variables so the Sendbird UI follows the active light/dark theme.
  '--sendbird-light-primary-500': 'var(--chat-primary-500)',
  '--sendbird-light-primary-400': 'var(--chat-primary-400)',
  '--sendbird-light-primary-300': 'var(--chat-primary-300)',
  '--sendbird-light-primary-200': 'var(--chat-primary-200)',
  '--sendbird-light-primary-100': 'var(--chat-primary-100)',
  '--sendbird-dark-primary-500': 'var(--chat-primary-500)',
  '--sendbird-dark-primary-400': 'var(--chat-primary-400)',
  '--sendbird-dark-primary-300': 'var(--chat-primary-300)',
  '--sendbird-dark-primary-200': 'var(--chat-primary-200)',
  '--sendbird-dark-primary-100': 'var(--chat-primary-100)',
};
